import styled from 'styled-components'
import { ReactComponent as StarOutlinedIcon } from 'assets/svg/icons/outlined/star.svg'
import { ReactComponent as StarIcon } from 'assets/svg/icons/filled/star.svg'

export const FavoriteButton = styled(StarOutlinedIcon)`
  height: 20px;
  transition: ${({ theme }) => theme.TRANSITION.fast};
  width: 20px;

  &:hover {
    cursor: pointer;
    opacity: 0.6;
  }
`

export const FavoriteButtonActive = styled(StarIcon)`
  height: 20px;
  transition: ${({ theme }) => theme.TRANSITION.fast};
  width: 20px;

  &:hover {
    cursor: pointer;
    opacity: 0.6;
  }
`
